export var version = "abstract-signer/5.0.14";